import {Services} from "@ca.vmedia.tv/services";
import type { AxiosError } from 'axios';
import { Logger } from '@/utils';

export enum ResourcesValues {
    FAQ_LINK = "faq_link",
    FORUM_LINK = "forum_link",
}

export type ResourcesUniversal = {
    resources: {
        [ResourcesValues.FAQ_LINK]: string;
        [ResourcesValues.FORUM_LINK]: string;
    };
}

export const useResourcesUniversal = async (resourceCode: string): Promise<ResourcesUniversal | null> => {
    try {
        const data = await Services.Instance.domains.resourcesRepository.getResources(resourceCode);
        return JSON.parse(data);
    } catch (error) {
        Logger.captureError(error as AxiosError | Error);
        return null;
    }
};
